import Session from '../../api/utilities/Session'

const LOGIN = 'LOGIN'
const LOGOUT = 'LOGOUT'
const PERSIST_TOKEN = 'PERSIST_TOKEN'
const CLEAR_TOKEN = 'CLEAR_TOKEN'

// Initial state
const state = {
  isLoggedIn: !!Session.get('token'),
  token: localStorage.getItem('token')
}

// Getters
const getters = {}

// Mutations
const mutations = {
  [LOGIN]: state => {
    state.isLoggedIn = true
  },

  [LOGOUT]: state => {
    state.isLoggedIn = true
  },

  [PERSIST_TOKEN]: (state, token) => {
    state.token = token
  },

  [CLEAR_TOKEN]: (state) => {
    state.token = null
  }
}

// Actions
const actions = {
  login: ({ commit }, token) => {
    Session.set('token', token)
    commit(LOGIN)
    commit(PERSIST_TOKEN, token)
  },

  logout: ({ commit }, token) => {
    Session.remove('token')
    commit(LOGOUT)
    commit(CLEAR_TOKEN)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js